/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ISchemaPropertyScope extends ng.IScope {
        model: SchemaPropertyModel;
        schemaProperty: Wars.Domain.Model.SchemaProperty;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        readOnly: boolean;
        propertyChangedCallback: () => void;
        reloadSchema: () => void;
        hideIsRequired: string;
        hideIsIndexed: string;
        defaultIsIndexedValue: string;
        defaultIsRequiredValue: string;
        allowTieToSystemVariable: string;
        allowTieToProcessName: string;
        isSystemLevel: string;
        systemVariableObjectSchema: Wars.Domain.Model.ObjectSchema;
        codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        listSystemVariables: Wars.Domain.Model.SchemaProperty[];
    }

    export class SchemaProperty implements IDirective {
        public link($scope: ISchemaPropertyScope, element: JQuery, attrs: ng.IAttributes, controller: SchemaPropertyController) { }
        public templateUrl = "./app/views/directives/schemaProperty.html";
        public restrict: string = "E";
        public controller = ["$scope", "schemaPropertyService", "deleteService", SchemaPropertyController];
        public controllerAs = "controller";
        public scope: any = {
            schemaProperty: "=",
            readOnly: "=",
            propertyChangedCallback: "=",
            processConfiguration: "=",
            reloadSchema: "=",
            hideIsRequired: "@",
            hideIsIndexed: "@",
            defaultIsIndexedValue: "@",
            defaultIsRequiredValue: "@",
            allowTieToSystemVariable: "@",
            allowTieToProcessName: '@',
            systemVariableObjectSchema: "=",
            isSystemLevel: "@",
            codeGroups: "="
        };
        compile = (element) => {
            return this.recursionHelper.compile(element);
        }

        private recursionHelper: any;

        constructor(recursionHelper: any) {
            this.recursionHelper = recursionHelper;
        }
    }

    export class SchemaPropertyModel {
        public defaultOption: models.CodeDropDownItem;
        public isNameProperty: boolean;

        constructor(
            public schemaProperty: Wars.Domain.Model.SchemaProperty,
            public processConfiguration: Wars.Domain.Model.ProcessConfiguration,
            public readOnly: boolean,
            public setPropertyChanged: () => void,
            private reloadSchema: () => void,
            private schemaPropertyService: services.SchemaPropertyService,
            private deleteService: services.DeleteService,
            private defaultIsIndexedValue: string,
            private defaultIsRequiredValue: string,
            private isSystemLevel: string,
            private allowTieToProcessName: string)
        {
            this.defaultOption = new models.CodeDropDownItem('Select...', null);

            this.isNameProperty = false;
            if (allowTieToProcessName === "true" && processConfiguration && processConfiguration.nameSchemaProperty_id === schemaProperty.id) {
                this.isNameProperty = true;
            }
        }

        public isNamePropertyChanged(): void {
            this.processConfiguration.nameSchemaProperty_id = this.isNameProperty
                ? this.schemaProperty.id
                : undefined;
        }

        public propertyTypeChanged(): void {
            if (this.schemaProperty) {
                if (this.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Object) {
                    alert("Objects are not implemented yet.");
                    this.schemaProperty.propertyType = null;
                }
            }
            this.setPropertyChanged();
        }

        public addListProperty(objectSchema: Wars.Domain.Model.ObjectSchema): void {
            var newProperty = this.schemaPropertyService.createNewSchemaProperty();
            this.setDefaults(newProperty);
            objectSchema.properties.push(newProperty);
            this.setPropertyChanged();
        }

        private setDefaults(propertySchema: Wars.Domain.Model.SchemaProperty): void {
            if (this.defaultIsIndexedValue === "true") {
                propertySchema.isIndexed = true;
            }
            else if (this.defaultIsIndexedValue === "false") {
                propertySchema.isIndexed = false;
            }

            if (this.defaultIsRequiredValue === "true") {
                propertySchema.required = true;
            }
            else if (this.defaultIsRequiredValue === "false") {
                propertySchema.required = false;
            }

            if (this.isSystemLevel === "true") {
                propertySchema.isSystemLevel = true;
            }
        }

        public delete(schemaProperty: Wars.Domain.Model.SchemaProperty): void {
            if (schemaProperty.entityAspect.entityState.isAdded()) {
                // “Added”	A new entity in cache that does not exist in the backend database.
                if (schemaProperty.typeSchema !== null) {
                    for (var i = 0; i < schemaProperty.typeSchema.properties.length; i++) {
                        schemaProperty.typeSchema.properties[i].entityAspect.setDeleted();
                    }
                }
                schemaProperty.entityAspect.setDeleted();
            } else {
                this.deleteService.deleteWithModalConfirmationIfNecessary(
                    "SchemaProperty",
                    schemaProperty.id,
                    "Successfully deleted variable",
                    () => { if (this.reloadSchema) this.reloadSchema(); },
                    "Could not delete variable");
            }

            this.setPropertyChanged();
        }
    }

    export class SchemaPropertyController implements IController {

        constructor(private $scope: ISchemaPropertyScope, schemaPropertyService: services.SchemaPropertyService, deleteService: services.DeleteService) {

            var propertyChangedFunction = () => {
                if ($scope.propertyChangedCallback) {
                    $scope.propertyChangedCallback();
                }
            };

            var reloadSchemaFunction = () => {
                if ($scope.reloadSchema) {
                    $scope.reloadSchema();
                }
            };

            $scope.model = new SchemaPropertyModel(
                $scope.schemaProperty,
                $scope.processConfiguration,
                $scope.readOnly,
                propertyChangedFunction,
                reloadSchemaFunction,
                schemaPropertyService,
                deleteService,
                $scope.defaultIsIndexedValue,
                $scope.defaultIsRequiredValue,
                $scope.isSystemLevel,
                $scope.allowTieToProcessName);

            $scope.$watch('schemaProperty', (newValue: Wars.Domain.Model.SchemaProperty) => {
                $scope.model.schemaProperty = newValue;
            });

            $scope.$watch('systemVariableObjectSchema', () => {
                this.loadListVariables();
            });
        }

        private loadListVariables(): void {
            if (this.$scope.systemVariableObjectSchema) {
                this.$scope.listSystemVariables = Enumerable.from(this.$scope.systemVariableObjectSchema.properties)
                    .where(i => i.typeSchema != null)
                    .selectMany(i => i.typeSchema.properties)
                    .toArray();
            }
        }
    }
}

warsApp.registerDirective('SchemaProperty', ["recursionHelper"]);